"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentStore = exports.actions = exports.EnvironmentActions = exports.mutations = exports.EnvironmentMutations = exports.EnvironmentInitialState = void 0;
var environment_service_1 = require("../../services/environment.service");
var EnvironmentInitialState = /** @class */ (function (_super) {
    __extends(EnvironmentInitialState, _super);
    function EnvironmentInitialState(configService, window) {
        var _this = _super.call(this, window) || this;
        _this.isEdgeLegacy = false;
        _this.isEdgeLegacy = _this.browser.family === environment_service_1.BrowserFamily.Edge && parseInt(_this.browser.version, 10) <= 44;
        return _this;
    }
    return EnvironmentInitialState;
}(environment_service_1.EnvironmentService));
exports.EnvironmentInitialState = EnvironmentInitialState;
var EnvironmentMutations;
(function (EnvironmentMutations) {
    EnvironmentMutations["SetPlatformVersion"] = "SetPlatformVersion";
})(EnvironmentMutations = exports.EnvironmentMutations || (exports.EnvironmentMutations = {}));
exports.mutations = {
    SetPlatformVersion: function (state, version) {
        state.platform.osVersion = version;
    },
};
var EnvironmentActions;
(function (EnvironmentActions) {
    EnvironmentActions["SetPlatformVersion"] = "environment/SetPlatformVersion";
})(EnvironmentActions = exports.EnvironmentActions || (exports.EnvironmentActions = {}));
exports.actions = {
    SetPlatformVersion: function (context) {
        return __awaiter(this, void 0, Promise, function () {
            var version;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, context.state.getPlatformVersion()];
                    case 1:
                        version = _a.sent();
                        if (version) {
                            context.commit(EnvironmentMutations.SetPlatformVersion, version);
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
};
var EnvironmentStore = /** @class */ (function () {
    function EnvironmentStore(configService, window) {
        this.actions = exports.actions;
        this.mutations = exports.mutations;
        this.namespaced = true;
        this.state = new EnvironmentInitialState(configService, window);
    }
    EnvironmentStore.namespace = 'environment';
    return EnvironmentStore;
}());
exports.EnvironmentStore = EnvironmentStore;
